import React from 'react'
import { XStack, YStack } from 'tamagui'

import { Card } from '@newComponents/Card'
import { Icon } from '@newComponents/Icon'
import { Paragraph } from '@newComponents/Text'
import { Link } from '@newComponents/Link'

import { DocSection } from '../shared/DocSection'
import { DocScreenshot } from '../shared/DocScreenshot'

const Embeds = () => (
  <>
    <Card gap='$4'>
      <Paragraph size='$5'>
        Event Embeds let you display your Event on external websites using an
        embeddable widget. This is useful for promoting Events on your
        organization's website, blog, or community forum without requiring
        visitors to leave the page.
      </Paragraph>
      <DocScreenshot
        src='docs/guilds/guild-settings-embeds.png'
        alt='Embeds settings page showing embed preview and HTML code snippet — Event Embeds follow the same pattern'
        caption='Event Embeds use the same embed code pattern as Guild Embeds'
      />
    </Card>

    <Card gap='$4'>
      <DocSection id='embed-usage' title='Using Embeds'>
        <YStack gap='$3'>
          <XStack gap='$3' alignItems='flex-start'>
            <Icon name='window-new' size='$5' color='$color' flexShrink={0} marginTop={2} />
            <Paragraph size='$5'>
              <Paragraph size='$5' fontWeight='$7'>Getting the embed code</Paragraph>{' '}
              — Navigate to your{' '}
              <Link href='/docs/events/page'>Event page</Link> and look for the embed
              or share options. Copy the embed code snippet, which is a small piece of
              HTML that you can paste into any website. The widget loads in an iframe
              with isolated styling, so it will not conflict with your site's CSS.
            </Paragraph>
          </XStack>
          <XStack gap='$3' alignItems='flex-start'>
            <Icon name='calendar' size='$5' color='$color' flexShrink={0} marginTop={2} />
            <Paragraph size='$5'>
              <Paragraph size='$5' fontWeight='$7'>What the embed shows</Paragraph>{' '}
              — The embedded widget displays the Event's cover photo, title, date and
              time, host Guild, and an action button for RSVPing or purchasing tickets.
              It provides a compact summary that encourages visitors to engage with the
              Event directly from your site.
            </Paragraph>
          </XStack>
          <XStack gap='$3' alignItems='flex-start'>
            <Icon name='link' size='$5' color='$color' flexShrink={0} marginTop={2} />
            <Paragraph size='$5'>
              <Paragraph size='$5' fontWeight='$7'>Keeping content in sync</Paragraph>{' '}
              — The embed always reflects the latest Event information. If you update
              the Event title, date, cover photo, or any other detail in{' '}
              <Link href='/docs/events/settings'>Event Settings</Link>, the embedded
              widget updates automatically — there is no need to regenerate or
              re-paste the embed code.
            </Paragraph>
          </XStack>
        </YStack>
      </DocSection>
    </Card>

    <Card gap='$4'>
      <DocSection id='guild-embeds' title='Guild Embeds'>
        <Paragraph size='$5'>
          For embedding your Guild's full profile or Events listing, see{' '}
          <Link href='/docs/guilds/embeds'>Guild Embeds</Link>.
        </Paragraph>
      </DocSection>
    </Card>
  </>
)

export default Embeds
